'use client'

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function LogoHeader() {
  const pathname = usePathname()
  return (
    <header className={pathname === "/acousticsguide" ? "bg-white" : "bg-black"}>
      <div className="grid grid-cols-1 gap-8 md:gap-32 md:grid-cols-2 px-gutter md:px-20 pt-12">
        <Link href="/" aria-label="Forte Home">
          {/* Use a plain img to avoid adding next/image config needs */}
          <img
            src="/full-logo.png"
            alt="Forte Opening Solutions"
            className="h-[48px] md:h-[70px] w-auto"
          />
        </Link>
      </div>
    </header>
  );
}
